module.exports = __webpack_public_path__ + "static/img/6265_phase_function_Paper_Points.076dc72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6265_phase_function_Paper_Points.png
// module id = iJzv
// module chunks = 0